var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EnterpriseSelector',{on:{"select":_vm.select}}),_c('v-divider'),_c('div',{staticClass:"s-vstack"},[_c('EnterpriseRegion')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }